import { useIntl } from "react-intl";
import {
  Box,
  Button,
  Menu,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

const sectionTitleSx = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "text.disabled",
  mb: 1,
};

const toggleButtonGroupSx = (theme) => ({
  "& .MuiToggleButton-root": {
    textTransform: "none",
    fontSize: 12,
    py: 0.75,
    borderColor: "rgba(0,0,0,0.1)",

    "&.Mui-selected": {
      backgroundColor: theme.palette.action.selected,
      color: "primary.dark",
      fontWeight: 600,
      borderColor: "primary.main",

      "&:hover": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
});

const IncomingOrdersSettingsMenu = ({
  anchorEl,
  open,
  onClose,
  theme,
  inspectorMode,
  tableDisplayMode,
  onInspectorModeChange,
  onDisplayModeChange,
  onOpenStatusManager,
}) => {
  const intl = useIntl();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        elevation: 3,
        sx: {
          mt: 0.75,
          minWidth: 280,
          borderRadius: "12px",
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
        },
      }}
    >
      <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
        <Typography sx={sectionTitleSx}>
          {intl.formatMessage({
            id: "incomingOrders.settings.orderDetails",
          })}
        </Typography>

        <ToggleButtonGroup
          value={inspectorMode}
          exclusive
          size="small"
          onChange={onInspectorModeChange}
          fullWidth
          sx={toggleButtonGroupSx(theme)}
        >
          <ToggleButton value="drawer">
            {intl.formatMessage({
              id: "incomingOrders.settings.sidePanel",
            })}
          </ToggleButton>

          <ToggleButton value="right">
            {intl.formatMessage({
              id: "incomingOrders.settings.right",
            })}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box
        sx={{
          borderTop: "1px solid rgba(0,0,0,0.06)",
          px: 2,
          pt: 1.5,
          pb: 2,
        }}
      >
        <Typography sx={sectionTitleSx}>
          {intl.formatMessage({
            id: "incomingOrders.settings.displayMode",
          })}
        </Typography>

        <ToggleButtonGroup
          value={tableDisplayMode}
          exclusive
          size="small"
          onChange={(_, value) => {
            if (value) {
              onDisplayModeChange(value);
            }
          }}
          fullWidth
          sx={toggleButtonGroupSx(theme)}
        >
          <ToggleButton value="pagination">
            {intl.formatMessage({
              id: "incomingOrders.settings.pagination",
            })}
          </ToggleButton>

          <ToggleButton value="infinite">
            {intl.formatMessage({
              id: "incomingOrders.settings.infiniteScroll",
            })}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box
        sx={{
          borderTop: "1px solid rgba(0,0,0,0.06)",
          px: 2,
          py: 1.25,
        }}
      >
        <Button
          size="small"
          onClick={onOpenStatusManager}
          sx={{
            textTransform: "none",
            fontSize: 12,
            color: "primary.main",

            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          {intl.formatMessage({
            id: "incomingOrders.settings.manageStatuses",
          })}
        </Button>
      </Box>
    </Menu>
  );
};

export default IncomingOrdersSettingsMenu;